/* ── ACCESSORIES SLIDER ── */
function accNav(sliderId, index) {
  var wrap = document.getElementById('acc-' + sliderId);
  var slides = wrap.querySelectorAll('.acc-slide');
  slides.forEach(function(s, i) { s.classList.toggle('active', i === index); });
  var dots = document.querySelectorAll('.acc-dots[data-id="' + sliderId + '"] .acc-dot');
  dots.forEach(function(d, i) { d.classList.toggle('active', i === index); });
}

/* ── ANNOUNCE BAR ── */
function syncAnnounceHeight() {
  var bar = document.getElementById('announceBar');
  if (bar) {
    var h = bar.classList.contains('hidden') ? 0 : bar.offsetHeight;
    document.documentElement.style.setProperty('--announce-h', h + 'px');
  }
  // Real nav height (nav-main + visible cta-strip; strip is hidden on mobile) → robust content clearance.
  var nav = document.getElementById('mainNav');
  if (nav) document.documentElement.style.setProperty('--nav-h', nav.offsetHeight + 'px');
}
var announceClose = document.getElementById('announceClose');
if (announceClose) {
  announceClose.addEventListener('click', function () {
    document.getElementById('announceBar').classList.add('hidden');
    document.documentElement.style.setProperty('--announce-h', '0px');
  });
}
syncAnnounceHeight();
window.addEventListener('resize', syncAnnounceHeight);

var heroVideo = document.getElementById('heroVideo');
if (heroVideo) {
  var _heroPlayed = false;
  heroVideo.addEventListener('playing', function() {
    _heroPlayed = true;
    var fb = document.querySelector('.hero-video-fallback');
    if (fb) fb.style.opacity = '0';
    var note = document.querySelector('.hero-lpm-note');
    if (note) note.style.display = 'none';
  });
  var heroShowLpmNote = function() {
    if (_heroPlayed) return;
    var note = document.querySelector('.hero-lpm-note');
    if (note) note.style.display = 'block';
  };
  var _hp = heroVideo.play();
  if (_hp && _hp.catch) _hp.catch(function(){ heroShowLpmNote(); });
  setTimeout(function(){ if (!_heroPlayed) heroShowLpmNote(); }, 3000);
}

/* ── NAV HAMBURGER ── */
function toggleNav() {
  var drawer = document.getElementById('navDrawer');
  var burger = document.getElementById('navHamburger');
  var isOpen = drawer.classList.toggle('open');
  burger.classList.toggle('open', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

/* ── CONFIGURATOR ── */
var cfgAnswers = {};
document.querySelectorAll('.config-opt').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var step = this.dataset.step;
    var val  = this.dataset.val;
    cfgAnswers[step] = val;
    document.querySelectorAll('#opts-' + step + ' .config-opt').forEach(function(b) { b.classList.remove('sel'); });
    this.classList.add('sel');
    var nextBtn = document.getElementById('next-' + step);
    if (nextBtn) nextBtn.disabled = false;
  });
});

function cfgNext(step) {
  if (!cfgAnswers[step]) return;
  setStep(step, 'done');
  setStep(step + 1, 'active');
  document.getElementById('panel-' + step).classList.remove('active');
  document.getElementById('panel-' + (step + 1)).classList.add('active');
  document.getElementById('configurator').scrollIntoView({ behavior: 'smooth', block: 'start' });
}
function cfgBack(step) {
  setStep(step, 'idle');
  setStep(step - 1, 'active');
  document.getElementById('panel-' + step).classList.remove('active');
  document.getElementById('panel-' + (step - 1)).classList.add('active');
  document.getElementById('configurator').scrollIntoView({ behavior: 'smooth', block: 'start' });
}
function cfgSubmit() {
  document.getElementById('panel-4').classList.remove('active');
  document.getElementById('panel-5').classList.add('active');
  setStep(4, 'done');
  document.getElementById('configurator').scrollIntoView({ behavior: 'smooth', block: 'start' });
}
function setStep(n, state) {
  var dot  = document.getElementById('dot-' + n);
  var name = document.getElementById('name-' + n);
  if (!dot) return;
  dot.className  = 'config-step-dot ' + state;
  name.className = 'config-step-name ' + (state === 'active' ? 'active' : 'idle');
}

/* ── LEAD TABS ── */
function switchLeadTab(type, el) {
  document.querySelectorAll('.lead-tab').forEach(function(t) { t.classList.remove('active'); });
  el.classList.add('active');
  document.querySelectorAll('.lead-form').forEach(function(f) { f.classList.remove('active'); });
  document.getElementById('lead-' + type).classList.add('active');
}

/* ── TRUSTPILOT REVIEWS ── */
var reviewsData = null;
var reviewsCurrentPage = 0;
var reviewsPerPage = 3;
var REVIEWS_TTL = 30 * 24 * 60 * 60 * 1000;
var REVIEWS_KEY = 'gk_reviews';
var REVIEWS_TS  = 'gk_reviews_ts';

function loadReviews() {
  if (!document.getElementById('reviews-grid')) return;
  var cached   = localStorage.getItem(REVIEWS_KEY);
  var cachedTs = localStorage.getItem(REVIEWS_TS);
  var now      = Date.now();
  if (cached && cachedTs && (now - parseInt(cachedTs)) < REVIEWS_TTL) {
    reviewsData = JSON.parse(cached);
    renderReviews();
    return;
  }
  fetch(window.REVIEWS_JSON_URL || 'reviews.json')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      reviewsData = data;
      localStorage.setItem(REVIEWS_KEY, JSON.stringify(data));
      localStorage.setItem(REVIEWS_TS, String(Date.now()));
      renderReviews();
    })
    .catch(function() {});
}

// 5-star reviews, optionally filtered to the current product (via #reviews-grid[data-product]).
// Falls back to all 5-star reviews when the product has none tagged yet.
function getReviews() {
  if (!reviewsData) return [];
  var list = reviewsData.reviews.filter(function(r) { return r.rating === 5; });
  var grid = document.getElementById('reviews-grid');
  var pf = grid && grid.getAttribute('data-product');
  if (!pf) return list;
  var key = pf.toLowerCase().split(' ')[0];
  var mine = list.filter(function(r) { return (r.product || '').toLowerCase().indexOf(key) > -1; });
  if (mine.length >= 3) return mine;
  // Top up sparse models to 3 with other 5-star reviews, skipping any that name a DIFFERENT model.
  var models = ['denis','henry','bristol','megan','lily','virgo'];
  var extra = list.filter(function(r) {
    if ((r.product || '').toLowerCase().indexOf(key) > -1) return false;
    var blob = ((r.title || '') + ' ' + (r.text || '')).toLowerCase();
    for (var i = 0; i < models.length; i++) { if (models[i] !== key && blob.indexOf(models[i]) > -1) return false; }
    return true;
  });
  return mine.concat(extra).slice(0, 3);
}

function renderReviews() {
  if (!reviewsData) return;
  var fiveStars  = getReviews();
  var totalPages = Math.ceil(fiveStars.length / reviewsPerPage);
  var ratingEl = document.getElementById('tp-rating');
  var totalEl  = document.getElementById('tp-total');
  var updEl    = document.getElementById('tp-updated');
  if (ratingEl) ratingEl.textContent = reviewsData.rating;
  if (totalEl)  totalEl.textContent  = reviewsData.total;
  if (updEl) {
    var d = new Date(reviewsData.lastUpdated);
    updEl.textContent = 'Last updated: ' + d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
  }
  var dotsEl = document.getElementById('reviews-dots');
  if (dotsEl) {
    dotsEl.innerHTML = '';
    for (var i = 0; i < totalPages; i++) {
      (function(idx) {
        var dot = document.createElement('div');
        dot.className = 'reviews-dot' + (idx === 0 ? ' active' : '');
        dot.onclick = function() { goToReviewsPage(idx); };
        dotsEl.appendChild(dot);
      })(i);
    }
  }
  goToReviewsPage(0);
}

function goToReviewsPage(page) {
  if (!reviewsData) return;
  var fiveStars  = getReviews();
  var totalPages = Math.ceil(fiveStars.length / reviewsPerPage);
  reviewsCurrentPage = Math.max(0, Math.min(page, totalPages - 1));
  var start  = reviewsCurrentPage * reviewsPerPage;
  var subset = fiveStars.slice(start, start + reviewsPerPage);
  var grid   = document.getElementById('reviews-grid');
  if (!grid) return;
  grid.innerHTML = '';
  subset.forEach(function(r, i) {
    var date = new Date(r.date).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
    var card = document.createElement('div');
    card.className = 'review-card';
    card.innerHTML = '<div class="review-stars">★★★★★</div><p class="review-text">"' + r.text + '"</p><p class="review-author">' + r.author + ' · ' + r.location + '</p><p class="review-meta">' + r.product + ' · ' + date + '</p>';
    grid.appendChild(card);
    setTimeout(function() { card.classList.add('visible'); }, i * 80);
  });
  document.querySelectorAll('.reviews-dot').forEach(function(d, i) { d.classList.toggle('active', i === reviewsCurrentPage); });
}

function reviewsNav(dir) {
  if (!reviewsData) return;
  var fiveStars  = getReviews();
  var totalPages = Math.ceil(fiveStars.length / reviewsPerPage);
  goToReviewsPage((reviewsCurrentPage + dir + totalPages) % totalPages);
}

loadReviews();

/* ── CART COUNT (live update after AJAX add-to-cart) ── */
window.gkCartRefresh = function() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(c) {
      var el = document.getElementById('navCartCount');
      if (el) el.textContent = c.item_count > 0 ? (' (' + c.item_count + ')') : '';
      var m = document.getElementById('navCartCountM');
      if (m) { if (c.item_count > 0) { m.textContent = c.item_count; m.hidden = false; } else { m.hidden = true; } }
    })
    .catch(function() {});
};

/* ── CHAT WIDGET ── */
var chatOpen = false;
function toggleChat() {
  chatOpen = !chatOpen;
  var bubble = document.getElementById('chatBubble');
  var iconMsg = document.getElementById('chat-icon-msg');
  var iconX   = document.getElementById('chat-icon-x');
  if (bubble)  bubble.style.display  = chatOpen ? 'none' : '';
  if (iconMsg) iconMsg.style.display = chatOpen ? 'none' : '';
  if (iconX)   iconX.style.display   = chatOpen ? '' : 'none';
}
